<template>
  <div>
    <div
      :class="`theme-main-menu sticky-menu theme-menu-five ${
        isSticky ? 'fixed' : ''
      }`"
    >
      <div class="d-flex align-items-center justify-content-center">
        <div v-if="dark" class="logo">
          <router-link to="/">
            <img src="../../../assets/images/RoboQuark.png" alt="" />
          </router-link>
        </div>
        <div v-else class="logo">
          <router-link to="/">
            <img src="../../../assets/images/RoboQuark.png" alt="" />
          </router-link>
        </div>

        <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
          <div class="nav-container">
            <button
              class="navbar-toggler"
              data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar"
              :class="menuActive ? 'navbar-toggler open' : 'navbar-toggler'"
              @click="menuActive = !menuActive"
            >
              <span></span>
            </button>
            <div
              :class="
                menuActive
                  ? 'navbar-collapse collapse ss'
                  : 'navbar-collapse collapse'
              "
              id="collapsibleNavbar"
            >
              <div class="d-lg-flex justify-content-between align-items-center">
                <ul
                  class="navbar-nav main-side-nav font-gordita"
                  id="one-page-nav"
                >
                <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/dashboard"
                      >Dashboard</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/"
                      >Home</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/#products"
                      >Products</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/#product"
                      >Features</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/#robo"
                      >Robots</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/#team"
                      >Team</a
                    >
                 
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/#faq"
                      >FAQ</a
                    >
                 
                  </li>
               
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="/blog"
                      >Blog</a
                    >
                 
                  </li>
                 
                 
              
                 
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <div class="right-widget">
          <a  @click="logout"
           
           
            class="demo-button"
          >
            <span>Logout</span>
            <img
              v-if="!dark"
              src="../../../assets/images/icon/user.svg"
              alt=""
            />
            <img
              v-if="dark"
              src="../../../assets/images/icon/user-w.svg"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>

    <!-- ContactModal start -->
    <ContactModal :dark="dark" />
    <!-- ContactModal end -->
  </div>
</template>

<script>
import megaMenus from "./mega-menus.vue";
import ContactModal from "../Modal/ContactModal.vue";

export default {
  name: "HeaderFive",
  components: {
    megaMenus,
    ContactModal,
  },
  props: {
    dark: Boolean,
    doc_signature: Boolean,
  },
  data() {
    return {
      isSticky: false,
      menuActive: false,
    };
  },
  methods: {
    handleSticky() {
      if (window.scrollY > 80) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    async logout() {
      try {
        // Perform the logout logic here
        // Example: Clear the user's token from local storage
        localStorage.removeItem('jwt');

        // If you're using Vuex, you might want to commit a mutation to clear the user state
        // this.$store.commit('CLEAR_USER_DATA');

        // Redirect the user to the login page or home page
        this.$router.push('/');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleSticky);
  },
};
</script>
